module.exports = __webpack_public_path__ + "img/STL6x6.5-Silk-Top-Lace-Front-Topper.01368bfd.jpg";